import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealSource";

export function selectByDealId(dealId) {
  console.log("parameter:", dealId)
  return axios({
    url: `/ws/${moduleName}/selectByDealId/${dealId}`,
    method: 'get',
  })
}

export default {
  selectByDealId,
}